export default "__VITE_ASSET__91ced9ec__"